import { useState, useEffect } from "react";
// import axios from "axios";

// Chakra imports
import {
  Box,
  SimpleGrid,
  useColorModeValue,
  Text,
  Button,
  Flex,
  Portal,
  Icon,
  useDisclosure,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuOptionGroup,
  MenuItemOption,
} from "@chakra-ui/react";
import { Table, Tbody, Th, Thead, Tr, Td } from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";

import { SidebarContext } from "contexts/SidebarContext";

import React from "react";

import Loader from "components/Loader";
import Navbar from "components/navbar/NavbarAdmin.js";

import Card from "components/card/Card";

import ModalAllPages from "components/pdf/ModalAllPages";
import { useNavigate } from "react-router-dom";
import Sidebar from "components/sidebar/Sidebar.js";
import {
  getActiveRoute,
  getActiveNavbar,
  getActiveNavbarText,
} from "helper/UploadFilePageHelper";

import routes from "routes.js";
import { useLocation } from "react-router-dom";
import { fileCLaimsExist } from "helper/UploadFilePageHelper";

import "App.css";
import { MinusIcon } from "@chakra-ui/icons";
import NFT from "components/card/NFT";

// Assets
import Nft2 from "assets/img/nfts/Nft2.png";

import { generalizeTableClaimJSON } from "utility/commonFunctions";

import pdf20520 from "assets/pdfs/claims/20520.pdf";
import pdf97001 from "assets/pdfs/claims/97001.pdf";
import pdf97003 from "assets/pdfs/claims/97003.pdf";
import pdf97035 from "assets/pdfs/claims/97035.pdf";

import { useSelector } from "react-redux";
import {
  selectUploadFileModuleData,
  selectUploadFileModuleFiles,
} from "redux/selectorFunctions";

export default function UserReports() {
  const selectUploadFileModuleDataRedux = useSelector(
    selectUploadFileModuleData
  );

  const selectUploadFileModuleFileRedux = useSelector(
    selectUploadFileModuleFiles
  );
  // --------------------------------------

  const location = useLocation();

  const navigate = useNavigate();
  const [files, setFiles] = useState([]);
  const [contraCTfiles, setcONTRACTFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const { onOpen } = useDisclosure();

  const [openModal, setOpenModal] = useState(false);
  const [showFilePreview, setShowFilePreview] = useState(false);
  const [filePreview, setFilePreview] = useState(null);
  const [formData, setFormData] = useState({});

  const [ElectronicfilePreview, setElectronicFilePreview] = useState(null);
  const [ShowElectronicfilePreview, setShowElectronicFilePreview] =
    useState(false);

  const [columnNames, setColumnNames] = useState([]);
  const [questions, setQuestions] = useState([]);

  const [isAlertQuestionModal, setIsAlertQuestionModal] = useState(false);
  const [claims, setClaims] = useState();
  const [selectedProviderName, setSelectedProviderName] = useState(null);

  const [tableData, setTableData] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [selectedProviders, setSelectedProviders] = useState([]);

  useEffect(() => {
    const table_data = generalizeTableClaimJSON(
      selectUploadFileModuleDataRedux
    );
    const files_data = selectUploadFileModuleFileRedux;

    setTableData(table_data);
    setcONTRACTFiles(files_data);

    const demoClaims = [
      {
        Provider_Name: "SARAH WILLIAMS",
        data: [
          {
            Provider_Name: "SARAH WILLIAMS",
            CPT_CODE: "64732",
            claim_number: "CLM-1001",
            RATE: "$120",
            Date: "2025-08-01",
            TAX_ID: "666543210",
            DESCRIPTION: "Transection or avulsion of; supraorbital nerve",
          },
          {
            Provider_Name: "SARAH WILLIAMS",
            CPT_CODE: "29705",
            claim_number: "CLM-1002",
            RATE: "$95",
            Date: "2025-08-01",
            TAX_ID: "666543210",
            DESCRIPTION: "Removal of bivalving; full arm or full leg cast",
          },
          {
            Provider_Name: "SARAH WILLIAMS",
            CPT_CODE: "27327",
            claim_number: "CLM-1003",
            RATE: "$110",
            Date: "2025-08-01",
            TAX_ID: "666543210",
            DESCRIPTION: "Excision tumor, soft tissue of thigh or knee area, subcutaneous; less than 3 cm",
          },
          {
            Provider_Name: "SARAH WILLIAMS",
            CPT_CODE: "20520",
            claim_number: "CLM-1004",
            RATE: "$75",
            Date: "2025-08-01",
            TAX_ID: "666543210",
            DESCRIPTION: "Removal of foreign body in muscle or tendon sheath; simple",
          },
        ],
      },
      {
        Provider_Name: "SOPHIA HARRIS",
        data: [
          {
            Provider_Name: "SOPHIA HARRIS",
            CPT_CODE: "97001",
            claim_number: "CLM-2001",
            RATE: "$130",
            Date: "2025-08-01",
            TAX_ID: "654321098",
            DESCRIPTION: "Transection or avulsion of; supraorbital nerve",
          },
          {
            Provider_Name: "SOPHIA HARRIS",
            CPT_CODE: "97003",
            claim_number: "CLM-2002",
            RATE: "$90",
            Date: "2025-08-01",
            TAX_ID: "654321098",
            DESCRIPTION: "Removal or bivalving; full arm or full leg cast",
          },
          {
            Provider_Name: "SOPHIA HARRIS",
            CPT_CODE: "97012",
            claim_number: "CLM-2003",
            RATE: "$105",
            Date: "2019-08-15",
            TAX_ID: "654321098",
            DESCRIPTION: "Excision tumor, soft tissue of thigh or knee area, subcutaneous; less than 3 cm",
          },
          {
            Provider_Name: "SOPHIA HARRIS",
            CPT_CODE: "97110",
            claim_number: "CLM-2004",
            RATE: "$115",
            Date: "2024-08-01",
            TAX_ID: "654321098",
            DESCRIPTION: "Application of a modality to one or more areas; electrical stimulation (unattended)",
          },
        ],
      },
    ];

    setClaims(demoClaims);
    setFiles([]);
    setLoading(false);
  }, [selectUploadFileModuleDataRedux, selectUploadFileModuleFileRedux]);

  const handleFormInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    let columnNames = [];
    let questions = [];

    for (const key in formData) {
      if (key.startsWith("column_name")) {
        columnNames.push(formData[key]);
      } else if (key.startsWith("question")) {
        questions.push(formData[key]);
      }
    }
    setColumnNames(columnNames);
    setQuestions(questions);
    setOpenModal(!openModal);
  };

  const handleClick = () => {
    if (files.length === 0) {
      alert("Please select files");
    } else {
      const matchOrder = [true, false, true, true, false, true, false];
      const demoResponse = files.map((f, index) => ({
        CPT_CODE: f.CPT_CODE,
        DESCRIPTION: f.DESCRIPTION,
        Date: f.Date,
        Provider_Name: f.Provider_Name,
        TAX_ID: f.TAX_ID,
        RATE: f.RATE,
        report: { status: { match: matchOrder[index % matchOrder.length] } },
      }));
      navigate("/report", {
        state: { data: demoResponse, files: contraCTfiles },
      });
    }
  };

  const handleProvidersChange = (providers) => {
    setSelectedProviders(providers);
    // Merge claims for selected providers, ensuring uniqueness
    const filtered = claims.filter((c) => providers.includes(c.Provider_Name));
    const combinedList = filtered.flatMap((c) => c.data);
    const uniqueKeys = new Set();
    const uniqueList = [];
    combinedList.forEach((obj) => {
      const key = JSON.stringify(obj);
      if (!uniqueKeys.has(key)) {
        uniqueKeys.add(key);
        uniqueList.push(obj);
      }
    });
    setFiles(uniqueList);
  };

  const pdfMap = {
    20520: pdf20520,
    97001: pdf97001,
    97003: pdf97003,
    97035: pdf97035,
  };

  async function fetchFileContent(cpt_code) {
    const pdf = pdfMap[cpt_code];

    // Demo: open local PDF
    setFilePreview(pdf);
    setShowFilePreview(true);
  }

  function handleObject(value) {
    if (typeof value === "string") {
      return value;
    } else if (value instanceof Array) {
      return value.join(", ");
    } else if (value instanceof Array) {
    } else if (value instanceof Object) {
      return Object.entries(value).map(([key, value]) => (
        <tr key={key}>
          <td className="border px-4 py-2">{key}</td>
          <td className="border px-4 py-2">{handleObject(value)}</td>
        </tr>
      ));
    } else {
    }
  }

  let icon1 = document.getElementById("icon1");
  let menu1 = document.getElementById("menu1");
  const showMenu1 = (flag) => {
    if (flag) {
      icon1.classList.toggle("rotate-180");
      menu1.classList.toggle("hidden");
    }
  };
  let icon2 = document.getElementById("icon2");

  const showMenu2 = (flag) => {
    if (flag) {
      icon2.classList.toggle("rotate-180");
    }
  };
  let icon3 = document.getElementById("icon3");

  const showMenu3 = (flag) => {
    if (flag) {
      icon3.classList.toggle("rotate-180");
    }
  };

  let Main = document.getElementById("Main");
  let open = document.getElementById("open");
  let close = document.getElementById("close");

  // ---------------------------
  // Chakra Color Mode
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const textColor = useColorModeValue("secondaryGray.900", "white");

  const textColorBrand = useColorModeValue("brand.500", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  const textHover = useColorModeValue(
    { color: "secondaryGray.900", bg: "unset" },
    { color: "secondaryGray.500", bg: "unset" }
  );
  const iconColor = useColorModeValue("brand.500", "white");
  const bgList = useColorModeValue("white", "whiteAlpha.100");
  const bgShadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.08)",
    "unset"
  );
  const bgButton = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const bgHover = useColorModeValue(
    { bg: "secondaryGray.400" },
    { bg: "whiteAlpha.50" }
  );
  const bgFocus = useColorModeValue(
    { bg: "secondaryGray.300" },
    { bg: "whiteAlpha.100" }
  );

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Box>
          <Box>
            <SidebarContext.Provider>
              <Sidebar />
              <Box
                float="right"
                minHeight="100vh"
                height="100%"
                overflow="auto"
                position="relative"
                maxHeight="100%"
                w={{ base: "100%", xl: "calc( 100% - 290px )" }}
                maxWidth={{ base: "100%", xl: "calc( 100% - 290px )" }}
                transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
                transitionDuration=".2s, .2s, .35s"
                transitionProperty="top, bottom, width"
                transitionTimingFunction="linear, linear, ease"
              >
                <Portal>
                  <Box>
                    <Navbar
                      onOpen={onOpen}
                      logoText={"Horizon UI Dashboard PRO"}
                      brandText={getActiveRoute(routes)}
                      secondary={getActiveNavbar(routes)}
                      message={getActiveNavbarText(routes)}
                      fixed={false}
                    />
                  </Box>
                </Portal>
                <Box
                  mx="auto"
                  p={{ base: "20px", md: "30px" }}
                  pe="20px"
                  minH="100vh"
                  pt="50px"
                >
                  <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
                    <>
                      {loading ? (
                        <Loader />
                      ) : (
                        <Box bg="white" borderRadius="md" boxShadow="sm" p={6}>
                          {/* Header row: Selected Claims + Dropdown (left) and Continue (right) */}
                          <Flex align="center" justify="space-between" mb={6}>
                            {/* Left side */}
                            <Flex align="center" gap={4}>
                              <Text fontSize="md" fontWeight="600">
                                Selected Claims
                              </Text>

                              <Menu closeOnSelect={false}>
                                <MenuButton
                                  as={Box}
                                  bg="white"
                                  px={4}
                                  py={2}
                                  borderRadius="md"
                                  borderWidth="1px"
                                  borderColor="gray.200"
                                  cursor="pointer"
                                  _hover={{ borderColor: "gray.300" }}
                                  _expanded={{ borderColor: "gray.400" }}
                                >
                                  <Flex
                                    justify="space-between"
                                    align="center"
                                    minW="200px"
                                  >
                                    <Box>Select</Box>
                                    <Icon
                                      as={ChevronDownIcon}
                                      w={5}
                                      h={5}
                                      ms={2}
                                    />
                                  </Flex>
                                </MenuButton>
                                <MenuList
                                  minW="240px"
                                  maxH="200px"
                                  overflowY="auto"
                                >
                                  <MenuOptionGroup
                                    type="checkbox"
                                    value={selectedProviders}
                                    onChange={handleProvidersChange}
                                  >
                                    {claims.map((claim) => (
                                      <MenuItemOption
                                        key={claim.Provider_Name}
                                        value={claim.Provider_Name}
                                      >
                                        {claim.Provider_Name}
                                      </MenuItemOption>
                                    ))}
                                  </MenuOptionGroup>
                                </MenuList>
                              </Menu>
                            </Flex>

                            {/* Right side */}
                            {files.length !== 0 && (
                              <Button
                                w="140px"
                                minW="140px"
                                variant="brand"
                                fontWeight="500"
                                onClick={handleClick}
                                borderRadius="10px"
                                h="50px"
                              >
                                Continue
                              </Button>
                            )}
                          </Flex>

                          {/* Details Section */}
                          {files.length > 0 ? (
                            <Table
                              variant="simple"
                              color="gray.500"
                              mb="24px"
                              size="md"
                              sx={{
                                "th, td": {
                                  borderBottom: "1px solid",
                                  borderColor: "gray.200",
                                },
                              }}
                            >
                              <Thead>
                                <Tr>
                                  <Th>Provider Name</Th>
                                  <Th>CPT Code</Th>
                                  <Th>Claim Number</Th>
                                  <Th>Rate</Th>
                                  <Th>Date of service</Th>
                                  <Th textAlign="right">Action</Th>
                                </Tr>
                              </Thead>

                              <Tbody>
                                {files.map((file, i) => (
                                  <Tr key={i}>
                                    <Td>{file.Provider_Name}</Td>
                                    <Td>{file.CPT_CODE}</Td>
                                    <Td>{file.claim_number}</Td>
                                    <Td>{file.RATE}</Td>
                                    <Td>{file.Date}</Td>
                                    <Td textAlign="right">
                                      <Button
                                        onClick={() => {
                                          if (
                                            fileCLaimsExist.includes(
                                              file.CPT_CODE
                                            )
                                          ) {
                                            fetchFileContent(file.CPT_CODE);
                                          } else {
                                            setElectronicFilePreview(file);
                                            setShowElectronicFilePreview(true);
                                          }
                                        }}
                                        variant="darkBrand"
                                        color="white"
                                        fontSize="sm"
                                        fontWeight="500"
                                        borderRadius="10px"
                                        px="24px"
                                        py="5px"
                                        bg="gray.500"
                                      >
                                        View
                                      </Button>
                                    </Td>
                                  </Tr>
                                ))}
                              </Tbody>
                            </Table>
                          ) : (
                            <Text
                              fontSize="sm"
                              color="gray.500"
                              textAlign="center"
                              py={6}
                            ></Text>
                          )}
                        </Box>
                      )}
                    </>
                  </Box>
                </Box>
              </Box>
            </SidebarContext.Provider>
          </Box>
        </Box>
      )}

      {filePreview === null ? (
        <></>
      ) : (
        <ModalAllPages
          filePreview={filePreview}
          setShowFilePreview={setShowFilePreview}
          showFilePreview={showFilePreview}
        />
      )}
      {ElectronicfilePreview === null ? (
        <></>
      ) : (
        <div
          id="staticModal"
          data-modal-backdrop="static"
          tabindex="-1"
          aria-hidden="true"
          class={`${
            ShowElectronicfilePreview ? "" : "hidden"
          } bg-card-backgroud-color  flex flex-col fixed top-[12%] rounded-lg left-[2.5%] right-[2.5%] z-50  w-[95%] h-[85%] p-4 overflow-x-hidden overflow-y-auto  `}
        >
          <div className=" h-[5%] text-end">
            <button
              onClick={() => {
                setShowElectronicFilePreview(!ShowElectronicfilePreview);
              }}
              type="button"
              class="text-color-text bg-transparent hover:bg-gray-200 hover:text-color-text rounded-lg text-sm p-1.5 ml-auto inline-flex items-center "
              data-modal-hide="staticModal"
            >
              <svg
                class="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </button>
          </div>
          <div className=" h-[95%]">
            <div className="h-[100%] w-full">
              <div className="App">
                <h4 className="text-color-text">
                  {ElectronicfilePreview.name}
                </h4>
                <table className="min-w-full border-collapse">
                  <thead>
                    <tr>
                      <th className="border bg-gray-200 px-4 py-2">Field</th>
                      <th className="border bg-gray-200 px-4 py-2 flex">
                        Description
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(ElectronicfilePreview).map(
                      ([key, value]) => (
                        <tr key={key}>
                          <td className="border px-4 py-2">{key}</td>
                          <td className="border px-4 py-2 flex">
                            {handleObject(value)}
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
